import React from 'react';
import { inject, observer } from 'mobx-react';
import storeLoader from 'app/stores/storeLoader';
import TestTable from 'app/views/synthetics/tests/TestTable';
import TestCollection from 'app/stores/synthetics/TestCollection';
import { action } from 'mobx';
import LoadingSkeleton from './LoadingSkeleton';

@storeLoader('$syn.tests', '$syn.agents')
@inject('$syn')
@observer
class SynResponse extends React.Component {
  state = { loading: true };

  applyFilters = (tests) => {
    const { query } = this.props;
    const test_type = query.get('query.test_type');
    const health = query.get('query.health');
    const display_name = query.get('query.test_name');
    const labels = query.get('query.tag_label');
    const filters = { test_type, health, display_name, labels };
    Object.entries(filters).forEach(([key, values]) => {
      if (!values) {
        delete filters[key];
      }
    });
    if (Object.keys(filters).length === 0) {
      return tests;
    }
    return tests.filter((test) =>
      Object.entries(filters)
        .map(([key, value]) => {
          if (key === 'labels' && test.labels?.length > 0) {
            const testLabels = test.labels.map((label) => label.get('name'));
            if (value?.some((label) => testLabels.includes(label))) {
              return true;
            }
          }
          let hasMatch = false;
          if (test.get(key)) {
            hasMatch = value.filter((i) => i.toLowerCase().includes(test.get(key).toLowerCase())).some((x) => x);
          }
          return hasMatch;
        })
        .every((result) => result)
    );
  };

  componentDidMount() {
    const { $syn } = this.props;
    // load usage data after call to load test health to handle timing issues with test deserialization after cache clears
    // see https://github.com/kentik/ui-app/issues/20806
    $syn.tests
      .loadTestHealth()
      .then(() => $syn.plan.loadUsageData())
      .then(() => {
        const collection = new TestCollection(this.applyFilters($syn.tests.original));
        // set b/c already loaded above
        action(() => (collection.healthLoaded = true));
        this.setState({ loading: false, collection });
      });
  }

  render() {
    const { loading, collection } = this.state;
    if (loading) {
      return <LoadingSkeleton />;
    }
    return <TestTable testCollection={collection} showSelectTest={false} />;
  }
}

export default SynResponse;
